import upload from './sp-upload.vue';
export default upload;